/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import { getQuestionFormComponentByType } from './question-type-map'

/**
 * @param {object} props
 * @param {FormQuestion} props.field
 */
const QuestionTypes = (props) => {

    const { field } = props
    const { type, isShown, group } = field || {}

    // show/hide question
    if (!isShown) {
        return null
    }

    const QuestionComponent = getQuestionFormComponentByType(type)

    // this is how the original code logically handled mismatches (i.e., it doesn't error out)
    if (!QuestionComponent) {
        return null
    }

    const isGroupQuestion = !!group;

    return isGroupQuestion ? (
        <div className="question-group-container">
            <QuestionComponent field={field} />
        </div>
    ) : <QuestionComponent field={field} />
}

export { QuestionTypes }
